// src/components/molecules/SubmissionDetails/ImageDisplaySection.js

import React, { useEffect } from "react";
import { Box } from "@mui/material";

const ImageDisplaySection = ({ submission, onAssetStatusChange }) => {

  useEffect(() => {
    // Attempt to load the large thumbnail image
    const img = new Image();
    img.src = `https://swayer.blob.core.windows.net/${submission.submissionSaleId}-pub/_thumb_large.jpg`;
    img.onload = () => {
      onAssetStatusChange(false); // Notify parent that assets are ready
    };
    img.onerror = () => {
      onAssetStatusChange(true); // Notify parent that assets are still processing
    };
  }, [submission, onAssetStatusChange]);

  return (
    <Box display="flex" justifyContent="center">
      <Box
        component="img"
        src={`https://swayer.blob.core.windows.net/${submission.submissionSaleId}-pub/${
          submission.challengeData && submission.challengeData.allowCrowdFunding
            ? "_thumb_large.jpg"
            : "_main_fullscreen.jpg"
        }`}
        alt="Submission Thumbnail"
        sx={{
          width: "50%",
          height: "auto",
          borderRadius: "25px",
          mb: 3,
        }}
      />
    </Box>
  );
};

export default ImageDisplaySection;
